import BotMessage from './BotMessage.js';


const botErrorCodes = Object.freeze({
    generic: 0,
    noResults: 2,
    botBlockedError: 3
});

/**
 * Bot errors that can be converted to BotMessage
 */
class BotError {
    constructor({
        code = botErrorCodes.generic,
        message = '',
        actionId = 0,
        end_chat = false
    }) {
        this.code = code;
        this.message = message;
        this.actionId = Number(actionId);
        this.end_chat = !!end_chat;
    }

    getMessage() {
        return new BotMessage({
            actionId: this.actionId,
            msg: this.message
        });
    }
}

export {
    botErrorCodes,
    BotError
};
